<template>

<section class="models-list mb-4 mt-4">
    <div class="row d-flex justify-content-center">
        <div v-if='isReady && models.length' 
                 v-for='m in models'
                 class="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex justify-content-center">

            <single-model :m='m' :key='m.id'></single-model>
        </div>
    </div>
</section>

</template>

<script>
    export default {

        mounted() {
            this.getData()
        },

        created() {
           
        },

        data() { 

            return {
                isReady : false,
                isLoading : false,

                models : [],
            }
            
        },

        methods : {

            getData() {

                this.isLoading = true;

                this.ajax.call('md:gtl', {}, (r) => {

                    this.isLoading = false;

                    if( r.status == 'success' ) {

                        this.models  = r.data.m;
                        this.isReady = true;
                        
                    }

                })

            }

        }

    }
</script>
